import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_IMAGE_URL, IMAGE_BASE_URL } from 'app/app.constants';
import { DisplayType } from 'entities/back-counter-tool';
import { Branch } from 'entities/branch';
import { Permission } from 'entities/enums';
import { Part } from 'entities/part';
import { getImageHelper } from 'helpers/get-image';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizationService } from 'services/authorization.service';

@Component({
    selector: 'part-card-item',
    templateUrl: './part-card-item.component.html',
    standalone: false
})
export class PartCardItemComponent implements OnInit, OnDestroy {
  @Input() idSuffix: string = "";
  @Input() part: Part;
  @Output() partChange = new EventEmitter<Part>();
  @Input() allowPriceAdjust: boolean;
  @Input() isInModal: boolean = false;
  @Output() navigateToPart = new EventEmitter<Part>();
  @Input() branch: Branch;
  @Input() displayType: DisplayType;

  canReturnCore$: Observable<boolean> = this.authorizationService.hasPermissionAsync(Permission.ReadCoreReturnOption)
    .pipe(
      map((hasPermission) => hasPermission && true)
    );

  private subscription: Subscription;

  constructor(
    private readonly authorizationService: AuthorizationService,
    private readonly router: Router,
    @Inject(IMAGE_BASE_URL) public imageBaseUrl: string,
    @Inject(DEFAULT_IMAGE_URL) public defaultImage: string
    ) {
  }

  ngOnInit() {
    this.subscription = this.canReturnCore$.subscribe();
    if (this.part.corePrice && this.part.coreOption == null) {
      this.part.coreOption = 'NOCORER';
    }
  }

  onExtendPart(extendedPartNumber: string) {
    this.router.navigate(['parts'], { queryParams: { searchTerm: extendedPartNumber } });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }

  onPartChange(part: Part) {
    this.partChange.emit(part);
  }

  onCoreOptionChange() {
    this.partChange.emit(this.part);
  }

  getImage(image: string, imageBaseUrl: string, imageSize: string) {
    return getImageHelper(image, imageBaseUrl, imageSize )
  }

  onImageClick(event: Event): void {
    if (this.isInModal) {
      event.preventDefault();
      this.navigateToPart.emit(this.part);
    }
  }

}
